import { ISection } from "../components/PlayerLanding/PlayerSearch/SelectAttributes";

const attributeSections: ISection[] = [
    {
        title: 'Physical',
        attributes: [
            { id: 'Height Cm', label: 'Height (cm)',displayName: 'Height (cm)', checked: false, percentile: 180, isMadeUpScore: false },
        ],
    },
    {
        title: 'Performance',
        attributes: [
            { id: 'Av. contribution score', label: 'Contribution score',displayName: 'Contribution score', checked: false, percentile: 80, isMadeUpScore: false },
        ],
    },
    {
        title: 'Final third',
        attributes: [
            { id: 'finishing-shots', label: 'Finishing - Shots',displayName: 'Finishing - Shots', checked: false, percentile: 80, isMadeUpScore: false },
            { id: 'finishing-aerial', label: 'Finishing - Aerial',displayName: 'Finishing - Aerial', checked: false, percentile: 80, isMadeUpScore: false },
            { id: 'attack-positioning', label: 'Attack positioning',displayName: 'Attack positioning', checked: false, percentile: 80 , isMadeUpScore: false},
        ],
    },
    {
        title: 'Build up play',
        attributes: [
            { id: 'creativity', label: 'Creativity',displayName: 'Creativity', checked: false, percentile: 80 , isMadeUpScore: false},
            { id: 'passing-accuracy', label: 'Passing accuracy',displayName: 'Passing accuracy', checked: false, percentile: 80, isMadeUpScore: false },
            { id: 'dribbling', label: 'Dribbling', checked: false,displayName: 'Dribbling', percentile: 80, isMadeUpScore: false },
            { id: 'crossing', label: 'Crossing', checked: false,displayName: 'Crossing', percentile: 80 , isMadeUpScore: false},
        ],
    },
    {
        title: 'Defence',
        attributes: [
            { id: 'tackling', label: 'Tackling',displayName: 'Tackling', checked: false, percentile: 80, isMadeUpScore: false },
            { id: 'defensive-headers', label: 'Defensive headers',displayName: 'Defensive headers', checked: false, percentile: 80 , isMadeUpScore: false},
            { id: 'aggression', label: 'Aggression',displayName: 'Ball Recovery', checked: false, percentile: 80, isMadeUpScore: false }
        ],
    },
];

const positionOptions = [
    { label: 'Their position', value: 'theirposition' },
    { label: 'All positions', value: 'allpositions' },
]

export { attributeSections, positionOptions };